<template>
  <form class="mt-2 flex items-baseline space-x-4" @submit.prevent="handleActivate">
    <m-input id="sid-activate" class="flex-grow" v-model="activationCode"/>
    <div class="relative">
      <m-button
        type="submit"
        :disable="loading"
        class="h-10"
        :class="{ 'cursor-not-allowed': loading }"
      >Activate</m-button>
      <div
        class="absolute inset-0 flex items-center justify-center bg-blue-700 rounded"
        v-if="loading"
      >
        <div class="h-4 w-4">
          <m-loader class="text-white"></m-loader>
        </div>
      </div>
    </div>
  </form>

</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';

export default {
  name: 'activate-code-form',
  props: {
    location: {
      type: String,
      default: 'Dashboard',
    },
  },
  data() {
    return {
      activationCode: null,
      loading: false,
    };
  },
  computed: {
    accountUUID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
  },
  methods: {
    handleActivate() {
      this.loading = true;
      const event = {
        location: this.location,
        type: 'ACTIVATE',
        accountUUID: this.accountUUID,
        code: this.activationCode,
      };

      API.post(ENDPOINTS.POST_ACTIVATE, {
        accountUUID: this.accountUUID,
        code: this.activationCode,
      })
        .then(() => {
          this.$mixpanel.track('activate-code-success', event);
          this.$gtm.trackEvent({
            event: 'conversion',
            category: 'purchase',
            action: 'activatedCode',
            label: `Code: ${this.activationCode}`,
            value: 1,
          });
          this.activationCode = '';
          this.loading = false;
          this.$emit('activated');
        })
        .catch((err) => {
          if (err.response.data.error.errorMessage === 'Trial already used for this app') {
            EventBus.$emit('addNotification', {
              title: 'Activation',
              icon: 'cross',
              message: 'This access code has already been redeemed.',
            });
          } else {
            EventBus.$emit('addNotification', {
              title: 'Activation',
              icon: 'cross',
              message: 'Unable to verfiy the access code. Please try again.',
            });
          }
          this.$mixpanel.track('activate-code-failed', event);
          this.activationCode = '';
          this.loading = false;
        });
    },
  },
};
</script>
